import { useTranslation } from 'react-i18next';
import { currencyFormat } from 'utils/number';
import { TextBetween } from './index.view';

interface DiscountDetailProps {
  discount: {
    discountPercentage?: number;
    priceSave?: number;
    code?: string;
  };
}

const DiscountDetail = ({ discount }: DiscountDetailProps) => {
  const { t } = useTranslation();
  const { discountPercentage, priceSave } = discount;
  return priceSave ? (
    <TextBetween>
      <div>
        {t('discount')}
        {discountPercentage ? (
          <>
            {` - `}
            {discountPercentage}
            {`%`}
          </>
        ) : null}
      </div>
      <div>-{currencyFormat(priceSave)}</div>
    </TextBetween>
  ) : null;
};

export default DiscountDetail;
